import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'light' | 'dark';
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={align === 'center' ? 'text-center' : 'text-left'} data-id="element-72" data-mp="3k0ozxapcw6fo">
      {eyebrow ? <p className={`text-[12px] font-extrabold uppercase tracking-[0.12em] ${isDark ? 'text-rose-light' : 'text-rose'}`} data-id="element-73" data-mp="bloh77c0aa4m">
          {eyebrow}
        </p> : null}
      <h2 className={`mt-2 font-display text-[28px] font-bold leading-[1.15] tracking-tight sm:text-4xl lg:text-[42px] ${isDark ? 'text-white' : 'text-navy'}`} data-id="element-74" data-mp="1uad0m940m55">
        {title}
      </h2>
      {subtitle ? <p className={`mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed sm:text-lg ${isDark ? 'text-white/75' : 'text-navy/70'} ${align === 'center' ? '' : 'mx-0'}`} data-id="element-75" data-mp="z9oaof0pcemw">
          {subtitle}
        </p> : null}
    </div>;
}